import IAddressDto from '../../../Common/types/Commands/Sodoor/IAddressDto';

const AddressInitialState: IAddressDto = {
  codePosti: '',
  mobile: '',
  telephone: '',
  neshani: '',
  cityCoreId: '',
  email: '',
};

export default AddressInitialState;
